import React from 'react';
import { PopoverProps as KendoPopoverProps, Popover as KendoPopover } from '@progress/kendo-react-tooltip';
import cn from 'clsx';

export interface PopoverProps extends KendoPopoverProps {
    'data-testid': string;
    isInfo: boolean;
    applyCallOutClass?: boolean;
}

export const Popover = ({
    children,
    'data-testid': testId,
    isInfo = false,
    applyCallOutClass = false,
    ...rest
}: PopoverProps) => {
    return (
        <KendoPopover
            className={cn({
                'info-details': isInfo,
                'bottom-right': applyCallOutClass,
            })}
            {...rest}
        >
            <div data-testid={testId}>{children}</div>
        </KendoPopover>
    );
};
